module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_07.1aafad3f.jpg";